import type {Worker} from "@mytour/shared";
import {Button} from "reactstrap";
import {useResendWorkerInvitation} from "../../../../query/teamWorkerQueries.js";

interface ResendWorkerInvitationActionProps {
  worker: Worker;
}

export function ResendWorkerInvitationAction({worker}: ResendWorkerInvitationActionProps) {
  const {resendWorkerInvitation, isResendingWorkerInvitation} = useResendWorkerInvitation();

  const handleResend = async () => {
    await resendWorkerInvitation(worker.id);
  };

  return (
    <Button
      size="sm"
      color="warning"
      onClick={handleResend}
      disabled={isResendingWorkerInvitation}
    >
      Renvoyer une invitation
    </Button>
  );
}
